import React from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

class AppHelmet extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const { pathname, yotpoSiteRating, yotpoSiteReviewCount } = this.props;
        return (
            <Helmet
                script={[
                    {
                        type: 'application/ld+json',
                        innerHTML: JSON.stringify({
                            ...{
                                '@context': 'https://schema.org',
                                '@type': 'Organization',
                                url: 'https://www.lenskart.com/',
                                name: 'Lenskart.com',
                                contactPoint: {
                                    '@type': 'ContactPoint',
                                    telephone: '+91-99998-99998',
                                    contactType: 'Customer Service'
                                },
                                sameAs: [
                                    'https://www.facebook.com/Lenskartindia',
                                    'https://in.pinterest.com/lenskartindia/',
                                    'https://twitter.com/Lenskart_com',
                                    'https://instagram.com/lenskart/',
                                    'https://www.youtube.com/lenskart',
                                    'https://www.linkedin.com/company/valyoo-technologies-pvt--ltd-/'
                                ],
                                logo: 'https://static.lenskart.com/media/mobile/images/lenskart_icon_512X512.png'
                            },
                            ...(['/', '/reviews'].includes(pathname) && yotpoSiteRating ?
                                {
                                    aggregateRating: {
                                        '@type': 'AggregateRating',
                                        ratingValue: yotpoSiteRating,
                                        bestRating: 5,
                                        reviewCount: yotpoSiteReviewCount
                                    }
                                } :
                                {}
                            )
                        })
                    },
                    {
                        type: 'application/ld+json',
                        innerHTML: JSON.stringify({
                            '@context': 'https://schema.org',
                            '@type': 'WebSite',
                            url: 'https://www.lenskart.com/',
                            potentialAction: {
                                '@type': 'SearchAction',
                                target: 'https://www.lenskart.com/search?q={search_term_string}',
                                'query-input': 'required name=search_term_string'
                            }
                        })
                    },
                ]}
            >
            </Helmet>
        );
    }
}

const mapStateToProps = state => ({
    yotpoSiteRating: state.yotpo.yotpoSiteRating,
    yotpoSiteReviewCount: state.yotpo.yotpoSiteReviewCount
});

export default connect(mapStateToProps)(AppHelmet);
